export enum DraggableWorkflowType {
	ActivityConfiguration = "ACTIVITY_CONFIGURATION"
}